///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.category_analyst = abcsetup.dashboard.category_analyst || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.category_analyst = {
    init: function() {
        // Cancel Maintenance button clicked
        $(document).on('click', '#new_maintenance_items .btn-cancel', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Cancel Maintenance', 'Are you sure you want to cancel maintenance on this item?', function (resp) {
                if (resp) {
                    abcsetup.dashboard.category_analyst.item_maintenance.delete(_this.data('id'), _this.data('type'));
                }
            });
        });

        // New item in process - delete button clicked
        $(document).on('click', '#app_data_tables_three_p_m_in_process_data_table .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/three_pm_import/' + _this.data('id')).then(response => {
                        window.location.reload();
                    });
                }
            });
        });

        // New item in process - delete button clicked
        $(document).on('click', '#app_data_tables_front_store_item_in_process_data_table .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this item?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/front_store/' + _this.data('id')).then(response => {
                        window.location.reload();
                    });
                }
            });
        });
    },

    deleteItem: (id) => {
        abcsetup.dashboard.showLoading($('#outstanding_panel'));

        axios.delete('/api/front_store/' + id).then((response) => {
            window.location.reload();
        });
    }
}
